import { render } from "./LoadingFull.vue?vue&type=template&id=c898c708&scoped=true"
const script = {}

import "./LoadingFull.vue?vue&type=style&index=0&id=c898c708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c898c708"]])

export default __exports__